// Menu v patičce jako harmonika (<paticka-harmonika>): na mobilu se nadpis menu stane tlačítkem
// a seznam odkazů je sbalený, na desktopu je vše otevřené a tlačítko neaktivní. Bez JS (element
// není definovaný) zůstává seznam vidět – section-footer.css skrývá jen :defined.
if (!customElements.get('paticka-harmonika')) {
  const mobil = window.matchMedia('(max-width: 749px)');

  customElements.define(
    'paticka-harmonika',
    class PatickaHarmonika extends HTMLElement {
      connectedCallback() {
        this.tlacitko = this.querySelector('.footer-block__prepinac');
        if (!this.tlacitko) return;
        this.nastav = this.nastav.bind(this);
        this.tlacitko.addEventListener('click', () => {
          this.toggleAttribute('otevreno');
          this.nastav();
        });
        mobil.addEventListener('change', this.nastav);
        this.nastav();
      }

      disconnectedCallback() {
        mobil.removeEventListener('change', this.nastav);
      }

      nastav() {
        this.tlacitko.disabled = !mobil.matches;
        this.tlacitko.setAttribute('aria-expanded', String(!mobil.matches || this.hasAttribute('otevreno')));
      }
    }
  );
}
